<template>
  <section class="dashboard-container flex flex-wrap flex-col">
    <SmartRow>
      <SmartTitle
        class="form-list__title lg:col-12 mb-2 mt-2"
        weight="medium"
        heading="1">
        KM
      </SmartTitle>
    </SmartRow>
    <SmartRow>
      <SmartButtonDash
        v-for="(service) in services"
        :key="service.title"
        :id="`${service.name}`"
        v-bind="service"
        @click.native="changeRoute(service.name)"
        :action="service.action"
        class="lg:col-4 md:col-12 sm:col-12 flex flex-wrap"
      />
    </SmartRow>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'KM',
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters({
      webPermission: 'auth/webPermission'
    }),
    services() {
      return this.items.filter(item => this.webPermission.find(p => p.name === item.permission));
    },
    items() {
      return [
        {
          title: 'Meus Endereços',
          description: 'Gerencie seus endereços',
          icon: 'pin',
          buttonText: 'Mais detalhes',
          iconColor: '#EA3D2F',
          permission: 'web.km.enderecos',
          name: 'MyAddress'
        },
        {
          title: 'Jornada',
          description: 'Visualize suas jornadas e solicite seu reembolso (Folha de Rosto).',
          icon: 'moneyReturn',
          buttonText: 'Mais detalhes',
          iconColor: '#F3A72E',
          permission: 'web.km.jornada',
          name: 'Journey'
        },
        {
          title: 'Histórico',
          description: 'Visualize o histórico de reembolso (Folha de Rosto).',
          icon: 'historic',
          buttonText: 'Mais detalhes',
          iconColor: '#66BB6A',
          permission: 'web.km.historico',
          name: 'History'
        },
        {
          title: 'Relatórios',
          description: 'Visualize os relatórios analísticos',
          icon: 'report',
          buttonText: 'Mais detalhes',
          iconColor: '#1C51AE',
          permission: 'web.km.relatorios',
          name: 'IconListReport'
        }
      ];
    }
  },

  methods: {
    changeRoute(routerName) {
      this.$router.push({ name: routerName });
    }
  }
};

</script>
